import Component from '../Component';
import Icon from './Icon';
export default class DetailedDropdownItem extends Component {
  view() {
    return m("button", {
      className: "DetailedDropdownItem hasIcon",
      onclick: this.attrs.onclick
    }, m(Icon, {
      name: this.attrs.active ? 'fas fa-check' : 'fas',
      className: "Button-icon"
    }), m("span", {
      className: "DetailedDropdownItem-content"
    }, m(Icon, {
      name: this.attrs.icon,
      className: "Button-icon"
    }), m("span", {
      className: "DetailedDropdownItem-label"
    }, m("strong", null, this.attrs.label), m("span", {
      className: "DetailedDropdownItem-description"
    }, this.attrs.description))));
  }
}
flarum.reg.add('core', 'common/components/DetailedDropdownItem', DetailedDropdownItem);